<template>
  <div id="login" style="caret-color:initial;" v-if="isVisible">
    <div class="jias">
      <div id="timeData">
        <span class="span1">
          北京时间：{{ getTime }}
        </span>
        <span class="span2">
          {{ getTimed }}
        </span>
      </div>
      <div style="color: #fff;position: absolute;bottom: 40px;right: 250px;width: 100px;">
        <viewer>
          <img src="../../static/img/app.png" alt="" width="100" height="100">
        </viewer>
        安卓APP
      </div>
      <div style="color: #fff;position: absolute;bottom: 40px;right: 140px;width: 100px;">
        <viewer>
          <img src="../../static/img/gzh.jpg" alt="" width="100" height="100">
        </viewer>
        公众号
      </div>
      <div style="color: #fff;position: absolute;bottom: 40px;right: 30px;width: 100px;">
        <viewer>
          <img src="../../static/img/xcx.jpg" alt="" width="100" height="100">
        </viewer>
        小程序
      </div>
    </div>
    <div class="layui-logo"><span>万安迪环境空气质量物联网平台</span></div>
    <div class="tastek-login">
      <div class="tastek-login-title">账号登陆</div>
      <div class="tastek-login-form" v-show="isShow">
        <div class="layui-form layui-form-pane">
          <div class="layui-form-item tastek-form-item">
            <label class="layui-form-label layui-icon label-icon layui-icon-username"></label>
            <div class="layui-input-block">
              <input type="text" name="username" v-model="loginForm.username" placeholder="请输入账号" class="layui-input">
            </div>
          </div>
          <div class="layui-form-item tastek-form-item">
            <label class="layui-form-label layui-icon label-icon layui-icon-password"></label>
            <div class="layui-input-block" style="position: relative;">
              <input :type="this.loginForm.pwdType" @on-change="loginForm.password" name="password"
                v-model="loginForm.password" placeholder="请输入密码" class="layui-input">
              <img @click="changeType()" src="../assets/img/pass.png"
                style="position: absolute;right: 12px;top: 12px;cursor: pointer;width: 18px;height: 18px;">
            </div>
          </div>
          <div class="layui-form-item tastek-form-item">
            <!-- <slider-verify-code v-model="loginForm.isLock"></slider-verify-code>

            <label class="layui-form-label layui-icon label-icon layui-icon-vercode"></label>
            <div class="layui-input-block">
              <input type="text" name="imageCode" v-model="loginForm.imageCode" id="login-verifyCode"
                placeholder="请输入验证码" class="layui-input" style="width:calc(100% - 110px);float: left;">
              <img class="codeimg" id="codeimg" :src="captchaPath" @click="getCaptcha()"
                style="width: 100px;float: left;height: 38px;margin-left: 10px;">
            </div> -->
          </div>
          <div class="layui-form-item tastek-form-item" style="color: #ffffff;text-align: left;">
            <!--            <input type="checkbox" name="rememberMe" lay-skin="primary" style="zoom: 1.4;vertical-align: middle;"><span-->
            <!--            class="rememberMe">自动登录</span>-->
            <div class="layui-form-item febs-tr" style="float: right;">
              <a class="mobile-login" @click="clickyz()">验证码登录</a>
            </div>
          </div>
          <button class="layui-btn tastek-login-btn btn-login" id="loginBtn" style="font-size: 16px;"
            @click="login">登陆</button>
        </div>
      </div>
      <div class="tastek-login-form" v-show="ishiden">
        <div class="layui-form layui-form-pane">
          <div class="layui-form-item tastek-form-item">
            <label class="layui-form-label layui-icon label-icon layui-icon-username"></label>
            <div class="layui-input-block">
              <input type="text" name="username" v-model="loginForm.mobile" placeholder="请输中国大陆手机号" class="layui-input">
            </div>
          </div>
          <div class="layui-form-item tastek-form-item">
            <label class="layui-form-label layui-icon label-icon layui-icon-vercode"></label>
            <div class="layui-input-block">
              <input type="text" name="imageCode" v-model="loginForm.code" id="login-verifyCode" placeholder="请输入验证码"
                class="layui-input" style="width:calc(100% - 110px);float: left;">
              <button class="layui-btn btn-login" @click="phone()">获取验证码</button>
            </div>
          </div>
          <div class="layui-form-item tastek-form-item" style="color: #ffffff;text-align: left;">
            <div class="layui-form-item febs-tr" style="float: right;">
              <a class="mobile-login" @click="clickyz()">账号登录</a>
            </div>
          </div>
          <button class="layui-btn tastek-login-btn btn-login" style="margin-top: 40px;font-size: 16px;"
            @click="loginPhone()">登陆
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
@import '../assets/layui/css/layui.css';
@import '../assets/css/login.css';
</style>

<script>
import { getUUID } from "@/utils";
import sliderVerifyCode from './components/slider-verify-code.vue';
import axios from "axios";

export default {
  name: "login",
  data() {
    return {
      captchaPath: '',
      getTime: "",
      getTimed: "",
      loginForm: {
        pwdType: "password",
        username: '',
        password: '',
        imageCode: '',
        imageCodeUuid: '',
        // isLock: false,
        mobile: '',
        code: '',
      },
      isShow: true,
      ishiden: false,
      isVisible: false
    }
  },
  created() {
    let _this = this

    this.currentTime();

    const urlParams = new URLSearchParams(window.location.search);
    const param1 = urlParams.get('token'); // value1
    if (param1 == null) {
      this.isVisible = true
      return
    }
    const loading = _this.$loading({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 1)'
    });
    let url = "https://c.szwandi.cn/iotApi/login/validate ";
    axios
      .get(url, {
        params: {},
        headers: {
          token: param1,
        }
      })
      .then(function (result) {
        if (result.data.code === 200) {
          _this.$cookie.set("iotAuthorization", result.data.data.iotAuthorization);

          // 清除 token 参数
          history.replaceState(null, "", window.location.pathname);
          _this.$router.replace({ name: "Home" });

          _this.$message.success("登陆成功")
          loading.close();
        } else {
          loading.close();
          _this.$message.error("Token 无效或已过期")
        }
      });
  },
  components: {
    'slider-verify-code': sliderVerifyCode
  },
  methods: {
    clickyz() {
      this.isShow = !this.isShow;
      this.ishiden = !this.ishiden;
    },
    //密码隐藏显示
    changeType() {
      this.loginForm.pwdType = this.loginForm.pwdType === 'password' ? 'text' : 'password';
    },
    //用户名 密码登录
    login() {
      // if (!this.loginForm.isLock) {
      //   this.$message.error("请拖动滑块完成验证")
      //   return
      // }
      this.$http({
        url: this.$http.adornUrl("login/slider"),
        method: "post",
        data: this.$http.adornData(this.loginForm),
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$cookie.set("iotAuthorization", data.data.iotAuthorization);
          this.$router.replace({ name: "Home" });
          this.$message.success("登陆成功")
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    //获取手机验证码
    phone() {
      if (this.loginForm.mobile === "") {
        this.$message.error("请输入手机号码不能为空");
      } else {
        this.$http({
          url: this.$http.adornUrl("/login/smsCode/" + this.loginForm.mobile),
          method: "get",
          data: this.$http.adornData(this.loginForm),
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.$message.success("短信发送成功");
          } else {
            this.$message.error(data.msg);
          }
        })
      }
    },
    //手机验证登陆接口
    loginPhone() {
      this.$http({
        url: this.$http.adornUrl("/login/phone"),
        method: "POST",
        data: this.$http.adornData(this.loginForm),
        params: this.$http.adornParams({
          'code': this.loginForm.code,
          'mobile': this.loginForm.mobile,
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$cookie.set("iotAuthorization", data.data.iotAuthorization);
          this.$router.replace({ name: "Home" });
          this.$message.success("登陆成功")
        } else {
          this.$message.error(data.msg);
        }
      })
    },
    //获取时间&&实时刷新定时器
    currentTime() {
      setInterval(this.getCurrentTime, 500);
    },
    getCurrentTime() {
      //获取当前时间并打印
      let _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
      _this.getTime = yy + '年' + mm + '月' + dd + '日';
      _this.getTimed = hh + ':' + mf + ':' + ss;
    },
  },
  beforeDestroy() {
    if (this.getCurrentTime) {
      clearInterval(this.getCurrentTime); // 在Vue实例销毁前，清除时间定时器
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login.vue